import { useEffect } from 'react';

import { useNotices } from '@/features/notices/useNotices';

export const useErrorHandlers = () => {
  const notices = useNotices();

  useEffect(() => {
    const handleError = (e: CustomEvent<{ collection: string }>) => {
      console.error({ e });
      notices.error('MyHub works in read-only mode. Your data wasn’t saved', { delay: 10 });
    };

    window.addEventListener('exported:sjWriteError', handleError);

    return () => {
      window.removeEventListener('exported:sjWriteError', handleError);
    };
  }, []);
};
